import { DataBean } from "../../DataBean";


export class SiteType extends DataBean {




    public async getSiteTypeCatalog(idState:any,regexStr: any, page: any, recordsPerPage: any): Promise<any> {
        return this.getCustomService("OrangeBase", "com.advantage.shared.Report_getSiteTypeCatalog_Number_String_Number_Number", [idState,regexStr, page, recordsPerPage]);
    }
public async deleteSiteType(idSiteType: any): Promise<any> {
        return this.getCustomService("OrangeBase", "com.advantage.shared.Report_getSiteTypeCatalog_Number_String_Number_Number", [idSiteType]);
    }
}